import React from 'react';
interface ProgressBarProps {
  completed: number;
  total: number;
}
const ProgressBar: React.FC<ProgressBarProps> = ({
  completed,
  total
}) => {
  const progressPercentage = completed / total * 100;
  return <>
      <div className="w-full h-2 bg-gray-200 rounded overflow-hidden mb-5" data-id="element-19">
        <div className="h-full bg-gradient-to-r from-[#2c5530] to-[#4a7c59] transition-all duration-300" style={{
        width: `${progressPercentage}%`
      }} data-id="element-20" />
      </div>
      <p className="text-center mb-5" data-id="element-21">
        <span data-id="element-22">
          {completed}/{total} questions completed
        </span>
      </p>
    </>;
};
export default ProgressBar;